import React from 'react';
import ParagraphText from 'components/Elements/ParagraphText/ParagraphText';
import AuthCard from 'features/auth/components/AuthCard/AuthCard';
import AuthFormHeader from 'features/auth/components/AuthFormHeader/AuthFormHeader';
import SignUpForm from 'features/auth/components/SignUpForm';

function SignUp() {
  return (
    <AuthCard>
      <AuthFormHeader>
        <ParagraphText marginTop={10} marginBottom={8}>
          Create your account
        </ParagraphText>
      </AuthFormHeader>
      <SignUpForm />
    </AuthCard>
  );
}

export default SignUp;
